import { downtimes as serviceName } from '../actions'
import { IDownTime } from '../interfaces/openHours.interfaces'
import { IAction } from '../interfaces/store.interfaces'

const initialState = [] as IDownTime[]

export const getDowntimesReducer = (state = initialState, action: IAction): IDownTime[] => {
  const { type, payload } = action
  switch (type) {
    case `GET_${serviceName}_BEGIN`:
      return state
    case `GET_${serviceName}_SUCCESS`:
      return payload
    case `GET_${serviceName}_FAILED`:
      return state
    default:
      return state
  }
}
